import { type SoundEffectName, SoundEffectPlayer } from "@/helpers/SoundPlayer";
import { usePersistentDataState } from "./usePersistentDataState";
import { useCallback } from "react";

export function useSoundEffects() {
  const [soundEffectsEnabled] = usePersistentDataState(
    "soundEffectsEnabled",
    true
  );

  // Move useCallback before any conditional returns
  const playSound = useCallback(
    (soundName: SoundEffectName, loop?: boolean) => {
      if (!soundEffectsEnabled) {
        return () => {};
      }
      
      // Create a promise that will resolve with the stop function
      const stopPromise = SoundEffectPlayer.play(soundName, loop);
      
      // Return a function that handles the promise properly
      return () => {
        // We need to handle the case where the component unmounts
        // before the sound is loaded and played
        stopPromise.then(stopFunc => stopFunc()).catch(e => {
          console.error("Error stopping sound effect:", e);
        });
      };
    },
    [soundEffectsEnabled]
  );

  // Return undefined if soundEffectsEnabled is undefined
  if (soundEffectsEnabled === undefined) {
    return undefined;
  }

  return playSound;
}